// Original project photography shared by rendered city pages and prerender SEO.
export const PROJECT_HERO_PHOTOS = {
  "ann-arbor": {
    "src": "/images/projects/maple-michigan-plank-site-finished-floor-living-room-ann-arbor-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/maple-michigan-plank-site-finished-floor-living-room-ann-arbor-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Living room with a 3¼ inch Michigan Plank first grade maple floor, site finished, Ann Arbor, MI",
    "city": "Ann Arbor, MI"
  },
  "harbor-springs": {
    "src": "/images/projects/maple-floor-invisible-finish-great-room-harbor-springs-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/maple-floor-invisible-finish-great-room-harbor-springs-mi.jpg",
    "width": 886,
    "height": 886,
    "alt": "Great room with a maple floor in an invisible finish, Harbor Springs, MI",
    "city": "Harbor Springs, MI"
  },
  "birmingham": {
    "src": "/images/projects/walnut-quartersawn-michigan-plank-floor-sunlit-room-birmingham-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/walnut-quartersawn-michigan-plank-floor-sunlit-room-birmingham-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Sunlit empty room with a Michigan Plank quarter sawn walnut floor, Birmingham, MI",
    "city": "Birmingham, MI"
  },
  "brighton": {
    "src": "/images/projects/european-white-oak-7-inch-floor-living-room-brighton-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/european-white-oak-7-inch-floor-living-room-brighton-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Living room with a 7 inch European white oak floor, Brighton, MI",
    "city": "Brighton, MI"
  },
  "plymouth": {
    "src": "/images/projects/white-oak-8-inch-custom-line-floor-kitchen-plymouth-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/white-oak-8-inch-custom-line-floor-kitchen-plymouth-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Kitchen with an 8 inch engineered 1 Wood Floors Custom Line white oak floor in Sand, Plymouth, MI",
    "city": "Plymouth, MI"
  },
  "livonia": {
    "src": "/images/projects/hickory-michigan-plank-fireside-8-inch-floor-dining-room-livonia-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/hickory-michigan-plank-fireside-8-inch-floor-dining-room-livonia-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Dining room with an 8 inch engineered Michigan Plank hickory floor in Fireside, Livonia, MI",
    "city": "Livonia, MI"
  },
  "farmington-hills": {
    "src": "/images/projects/red-oak-staircase-dusky-walnut-floor-farmington-hills-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/red-oak-staircase-dusky-walnut-floor-farmington-hills-mi.jpg",
    "width": 960,
    "height": 720,
    "alt": "Curved staircase with color matched red oak treads over a hand scraped Dusky Walnut floor, Farmington Hills, MI",
    "city": "Farmington Hills, MI"
  },
  "northville": {
    "src": "/images/projects/hickory-michigan-plank-floor-dining-room-northville-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/hickory-michigan-plank-floor-dining-room-northville-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Dining room with a Michigan Plank hickory floor in a natural finish, Northville, MI",
    "city": "Northville, MI"
  },
  "novi": {
    "src": "/images/projects/walnut-rift-quartered-michigan-plank-floor-living-room-kitchen-novi-mi.jpg",
    "url": "https://1woodfloors.com/images/projects/walnut-rift-quartered-michigan-plank-floor-living-room-kitchen-novi-mi.jpg",
    "width": 1920,
    "height": 1280,
    "alt": "Open living room and kitchen with a Michigan Plank rift and quartered walnut floor in 2 to 5 inch widths, Novi, MI",
    "city": "Novi, MI"
  }
};

export const CITY_HERO_PHOTOS = {
  "ann-arbor": { ...PROJECT_HERO_PHOTOS["ann-arbor"], caption: "" },
  "chelsea": { ...PROJECT_HERO_PHOTOS["ann-arbor"], caption: "Pictured: a 1 Wood Floors project in Ann Arbor, MI" },
  "dexter": { ...PROJECT_HERO_PHOTOS["ann-arbor"], caption: "Pictured: a 1 Wood Floors project in Ann Arbor, MI" },
  "pinckney": { ...PROJECT_HERO_PHOTOS["ann-arbor"], caption: "Pictured: a 1 Wood Floors project in Ann Arbor, MI" },
  "saline": { ...PROJECT_HERO_PHOTOS["ann-arbor"], caption: "Pictured: a 1 Wood Floors project in Ann Arbor, MI" },
  "ypsilanti": { ...PROJECT_HERO_PHOTOS["ann-arbor"], caption: "Pictured: a 1 Wood Floors project in Ann Arbor, MI" },
  "harbor-springs": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "" },
  "bay-harbor": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "Pictured: a 1 Wood Floors project in Harbor Springs, MI" },
  "bellaire": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "Pictured: a 1 Wood Floors project in Harbor Springs, MI" },
  "charlevoix": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "Pictured: a 1 Wood Floors project in Harbor Springs, MI" },
  "leelanau": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "Pictured: a 1 Wood Floors project in Harbor Springs, MI" },
  "petoskey": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "Pictured: a 1 Wood Floors project in Harbor Springs, MI" },
  "traverse-city": { ...PROJECT_HERO_PHOTOS["harbor-springs"], caption: "Pictured: a 1 Wood Floors project in Harbor Springs, MI" },
  "birmingham": { ...PROJECT_HERO_PHOTOS["birmingham"], caption: "" },
  "bloomfield-hills": { ...PROJECT_HERO_PHOTOS["birmingham"], caption: "Pictured: a 1 Wood Floors project in Birmingham, MI" },
  "orchard-lake": { ...PROJECT_HERO_PHOTOS["birmingham"], caption: "Pictured: a 1 Wood Floors project in Birmingham, MI" },
  "rochester-hills": { ...PROJECT_HERO_PHOTOS["birmingham"], caption: "Pictured: a 1 Wood Floors project in Birmingham, MI" },
  "troy": { ...PROJECT_HERO_PHOTOS["birmingham"], caption: "Pictured: a 1 Wood Floors project in Birmingham, MI" },
  "west-bloomfield": { ...PROJECT_HERO_PHOTOS["birmingham"], caption: "Pictured: a 1 Wood Floors project in Birmingham, MI" },
  "brighton": { ...PROJECT_HERO_PHOTOS["brighton"], caption: "" },
  "plymouth": { ...PROJECT_HERO_PHOTOS["plymouth"], caption: "" },
  "canton": { ...PROJECT_HERO_PHOTOS["plymouth"], caption: "Pictured: a 1 Wood Floors project in Plymouth, MI" },
  "livonia": { ...PROJECT_HERO_PHOTOS["livonia"], caption: "" },
  "dearborn": { ...PROJECT_HERO_PHOTOS["livonia"], caption: "Pictured: a 1 Wood Floors project in Livonia, MI" },
  "grosse-pointe": { ...PROJECT_HERO_PHOTOS["livonia"], caption: "Pictured: a 1 Wood Floors project in Livonia, MI" },
  "farmington-hills": { ...PROJECT_HERO_PHOTOS["farmington-hills"], caption: "" },
  "northville": { ...PROJECT_HERO_PHOTOS["northville"], caption: "" },
  "novi": { ...PROJECT_HERO_PHOTOS["novi"], caption: "" },
  "south-lyon": { ...PROJECT_HERO_PHOTOS["novi"], caption: "Pictured: a 1 Wood Floors project in Novi, MI" },
  "wixom": { ...PROJECT_HERO_PHOTOS["novi"], caption: "Pictured: a 1 Wood Floors project in Novi, MI" },
};

export const DEFAULT_SHARE_IMAGE = PROJECT_HERO_PHOTOS.plymouth;

export function makeCityWebPageSchema(slug) {
  const photo = CITY_HERO_PHOTOS[slug];
  if (!photo) return undefined;
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    url: `https://1woodfloors.com/hardwood-flooring/${slug}-mi`,
    primaryImageOfPage: {
      "@type": "ImageObject",
      contentUrl: photo.url,
      url: photo.url,
      width: photo.width,
      height: photo.height,
      caption: photo.alt,
      contentLocation: { "@type": "Place", name: photo.city },
      creator: { "@id": "https://1woodfloors.com/#localbusiness" },
      copyrightHolder: { "@id": "https://1woodfloors.com/#localbusiness" },
    },
  };
}

export const PROJECT_IMAGE_ALTS = {
  "lexington-reclaimed-oak-floor-fir-ceiling-great-room": "Great room with a reclaimed hit skip oak floor under a Douglas fir ceiling, Lexington, MI",
  "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi": "Close up of a wire brushed oak floor in a dark brown finish after refinishing, Brighton, MI",
  "subfloor-hero": "Laser level line across a concrete subfloor being leveled",
  "inspection-hero": "Moisture meter pins pressed into an oak floor during an inspection",
  "product-spec-hero": "End grain growth rings on a cross cut hardwood log",
  "acclimation-hero": "Moisture meter resting on a wood plank",
  "commercial-ann-arbor": "Commercial staircase and engineered oak floor refinished with Pallmann Magic Oil, Ann Arbor, MI",
  "staircase-renovations-hero": "Curved staircase with color matched red oak treads over a hand scraped Dusky Walnut floor, Farmington Hills, MI",
  "northville-walnut-open-floor-kitchen": "Open kitchen and living area with an 8 inch engineered FAS walnut floor, Northville, MI",
  "northville-walnut-great-room-fireplace": "Great room with a stone fireplace and an 8 inch FAS walnut floor, Northville, MI",
  "engineered-self-leveling-underlayment-concrete-livonia": "Self leveling underlayment poured over primed concrete before an 8 inch hickory install, Livonia, MI",
  "deep-self-leveling-underlayment-pour-ann-arbor-mi": "Deep self leveling underlayment pour correcting a 1.5 inch height variance, Ann Arbor, MI"
};

export function projectImageAlt(src, fallback = "") {
  const filename = (src?.split("/").pop() || "")
    .replace("ann-arbor-tech-staircase-hero", "commercial-ann-arbor")
    .replace("custom-8-inch-walnut-fas-northville-mi", "northville-walnut-open-floor-kitchen");
  const entry = Object.entries(PROJECT_IMAGE_ALTS).find(([name]) => filename === `${name}.webp` || filename.startsWith(`${name}-`));
  return entry ? entry[1] : fallback;
}

export const CITY_OWNED_IMAGES = {
  "livonia": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "staircase-renovations-hero",
    "northville-walnut-open-floor-kitchen",
    "engineered-self-leveling-underlayment-concrete-livonia"
  ],
  "northville": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "staircase-renovations-hero",
    "northville-walnut-open-floor-kitchen",
    "northville-walnut-great-room-fireplace"
  ],
  "novi": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "commercial-ann-arbor"
  ],
  "wixom": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "plymouth": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "staircase-renovations-hero",
    "northville-walnut-great-room-fireplace",
    "engineered-self-leveling-underlayment-concrete-livonia"
  ],
  "ann-arbor": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "commercial-ann-arbor",
    "staircase-renovations-hero",
    "northville-walnut-open-floor-kitchen",
    "deep-self-leveling-underlayment-pour-ann-arbor-mi"
  ],
  "canton": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "farmington-hills": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "staircase-renovations-hero"
  ],
  "west-bloomfield": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "birmingham": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "commercial-ann-arbor",
    "staircase-renovations-hero",
    "northville-walnut-open-floor-kitchen"
  ],
  "bloomfield-hills": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "staircase-renovations-hero"
  ],
  "troy": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "commercial-ann-arbor",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "rochester-hills": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "dearborn": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "grosse-pointe": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "brighton": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "staircase-renovations-hero"
  ],
  "saline": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "ypsilanti": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "traverse-city": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi",
    "staircase-renovations-hero"
  ],
  "petoskey": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "harbor-springs": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "charlevoix": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "south-lyon": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "orchard-lake": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "dexter": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "chelsea": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "pinckney": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "bellaire": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "bay-harbor": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ],
  "leelanau": [
    "lexington-reclaimed-oak-floor-fir-ceiling-great-room",
    "wire-brushed-oak-dustless-sanding-refinishing-brighton-mi"
  ]
};
